module.exports = ".row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    margin-bottom: -10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/property-register/propertyregister-form/propertyregister-form.component.css
// module id = ./src/app/allocation/property-register/propertyregister-form/propertyregister-form.component.css
// module chunks = main